var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path, _path2, _rect11, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanDesigned1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 318,
    height: 170,
    viewBox: "0 0 318 170",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 48 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 102 0)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 156 0)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 210 0)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 264 0)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 318,
    width: 170,
    height: 48,
    rx: 8,
    transform: "rotate(90 318 0)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 32.5,
    width: 137,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 47.5 32.5)",
    fill: "#E6988C",
    stroke: "#C97D70"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 91.5,
    width: 78,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 101.5 91.5)",
    fill: "#E6B18C",
    stroke: "#CD9A76"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 155.5,
    y: 60.5,
    width: 109,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 155.5 60.5)",
    fill: "#F3CD9C",
    stroke: "#E0AA73"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 209.5,
    y: 102.5,
    width: 67,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 209.5 102.5)",
    fill: "#F3E69D",
    stroke: "#DFDA87"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 263.5,
    y: 120.5,
    width: 49,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 263.5 120.5)",
    fill: "#9CE578",
    stroke: "#79CB52"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 317.5,
    y: 140.5,
    width: 29,
    height: 47,
    rx: 7.5,
    transform: "rotate(90 317.5 140.5)",
    fill: "#91D2F5",
    stroke: "#62A4C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.231 130.035C246.198 130.035 251.035 125.198 251.035 119.231C251.035 113.265 246.198 108.428 240.231 108.428C234.265 108.428 229.428 113.265 229.428 119.231C229.428 125.198 234.265 130.035 240.231 130.035Z",
    fill: "white",
    stroke: "#76CB52",
    strokeWidth: 5.14465
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.286 101.002C240.885 101.511 240.115 101.511 239.714 101.002L235.279 95.3686C234.763 94.7126 235.23 93.75 236.065 93.75H244.935C245.77 93.75 246.237 94.7126 245.721 95.3686L241.286 101.002Z",
    fill: "#71BD50"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 72,
    width: 43,
    height: 25,
    rx: 2,
    fill: "#71BD50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.179 82.0298C234.096 81.7713 233.985 81.5398 233.846 81.3352C233.71 81.1278 233.546 80.9517 233.356 80.8068C233.166 80.6591 232.948 80.5469 232.704 80.4702C232.463 80.3935 232.197 80.3551 231.907 80.3551C231.416 80.3551 230.973 80.4815 230.578 80.7344C230.183 80.9872 229.87 81.358 229.64 81.8466C229.413 82.3324 229.299 82.9276 229.299 83.6321C229.299 84.3395 229.414 84.9375 229.645 85.4261C229.875 85.9148 230.19 86.2855 230.591 86.5384C230.991 86.7912 231.447 86.9176 231.958 86.9176C232.433 86.9176 232.846 86.821 233.198 86.6278C233.554 86.4347 233.828 86.1619 234.021 85.8097C234.217 85.4545 234.315 85.0369 234.315 84.5568L234.656 84.6207H232.159V83.5341H235.589V84.527C235.589 85.2599 235.433 85.8963 235.12 86.4361C234.811 86.973 234.382 87.3878 233.833 87.6804C233.288 87.973 232.663 88.1193 231.958 88.1193C231.169 88.1193 230.475 87.9375 229.879 87.5739C229.285 87.2102 228.822 86.6946 228.49 86.027C228.157 85.3565 227.991 84.5611 227.991 83.6406C227.991 82.9446 228.088 82.3196 228.281 81.7656C228.474 81.2116 228.745 80.7415 229.095 80.3551C229.447 79.9659 229.86 79.669 230.335 79.4645C230.812 79.2571 231.333 79.1534 231.899 79.1534C232.37 79.1534 232.809 79.223 233.216 79.3622C233.625 79.5014 233.988 79.6989 234.306 79.9545C234.627 80.2102 234.893 80.5142 235.103 80.8665C235.314 81.2159 235.456 81.6037 235.529 82.0298H234.179ZM240.027 88.1321C239.413 88.1321 238.878 87.9915 238.42 87.7102C237.963 87.429 237.608 87.0355 237.355 86.5298C237.102 86.0241 236.976 85.4332 236.976 84.7571C236.976 84.0781 237.102 83.4844 237.355 82.9759C237.608 82.4673 237.963 82.0724 238.42 81.7912C238.878 81.5099 239.413 81.3693 240.027 81.3693C240.64 81.3693 241.176 81.5099 241.633 81.7912C242.091 82.0724 242.446 82.4673 242.699 82.9759C242.951 83.4844 243.078 84.0781 243.078 84.7571C243.078 85.4332 242.951 86.0241 242.699 86.5298C242.446 87.0355 242.091 87.429 241.633 87.7102C241.176 87.9915 240.64 88.1321 240.027 88.1321ZM240.031 87.0625C240.429 87.0625 240.758 86.9574 241.02 86.7472C241.281 86.5369 241.474 86.2571 241.599 85.9077C241.727 85.5582 241.791 85.1733 241.791 84.7528C241.791 84.3352 241.727 83.9517 241.599 83.6023C241.474 83.25 241.281 82.9673 241.02 82.7543C240.758 82.5412 240.429 82.4347 240.031 82.4347C239.63 82.4347 239.298 82.5412 239.034 82.7543C238.772 82.9673 238.578 83.25 238.45 83.6023C238.325 83.9517 238.263 84.3352 238.263 84.7528C238.263 85.1733 238.325 85.5582 238.45 85.9077C238.578 86.2571 238.772 86.5369 239.034 86.7472C239.298 86.9574 239.63 87.0625 240.031 87.0625ZM246.516 88.1449C246.101 88.1449 245.726 88.0682 245.391 87.9148C245.056 87.7585 244.79 87.5327 244.594 87.2372C244.401 86.9418 244.305 86.5795 244.305 86.1506C244.305 85.7812 244.376 85.4773 244.518 85.2386C244.66 85 244.851 84.8111 245.093 84.6719C245.334 84.5327 245.604 84.4276 245.903 84.3565C246.201 84.2855 246.505 84.2315 246.815 84.1946C247.207 84.1491 247.525 84.1122 247.769 84.0838C248.013 84.0526 248.191 84.0028 248.302 83.9347C248.413 83.8665 248.468 83.7557 248.468 83.6023V83.5724C248.468 83.2003 248.363 82.9119 248.153 82.7074C247.945 82.5028 247.636 82.4006 247.224 82.4006C246.795 82.4006 246.457 82.4957 246.209 82.6861C245.965 82.8736 245.796 83.0824 245.702 83.3125L244.505 83.0398C244.647 82.642 244.854 82.321 245.127 82.0767C245.403 81.8295 245.719 81.6506 246.077 81.5398C246.435 81.4261 246.812 81.3693 247.207 81.3693C247.468 81.3693 247.745 81.4006 248.038 81.4631C248.333 81.5227 248.609 81.6335 248.864 81.7955C249.123 81.9574 249.334 82.1889 249.499 82.4901C249.664 82.7884 249.746 83.1761 249.746 83.6534V88H248.502V87.1051H248.451C248.368 87.2699 248.245 87.4318 248.08 87.5909C247.915 87.75 247.704 87.8821 247.445 87.9872C247.187 88.0923 246.877 88.1449 246.516 88.1449ZM246.793 87.1222C247.145 87.1222 247.447 87.0526 247.697 86.9134C247.949 86.7741 248.141 86.5923 248.272 86.3679C248.405 86.1406 248.472 85.8977 248.472 85.6392V84.7955C248.427 84.8409 248.339 84.8835 248.208 84.9233C248.08 84.9602 247.934 84.9929 247.769 85.0213C247.604 85.0469 247.444 85.071 247.288 85.0938C247.131 85.1136 247.001 85.1307 246.895 85.1449C246.648 85.1761 246.422 85.2287 246.218 85.3026C246.016 85.3764 245.854 85.483 245.732 85.6222C245.613 85.7585 245.553 85.9403 245.553 86.1676C245.553 86.483 245.67 86.7216 245.903 86.8835C246.136 87.0426 246.432 87.1222 246.793 87.1222ZM252.829 79.2727V88H251.555V79.2727H252.829Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanDesigned1);
export default __webpack_public_path__ + "static/media/plan_designed1.00fa6d2c5f748110ecc66728c6bd628a.svg";
export { ForwardRef as ReactComponent };